import { memo } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import { useQuery } from '@tanstack/react-query'
import SolidPlayIcon from 'LuxKit/Icons/solid/SolidPlayIcon'

interface Props {
  vimeoVideoId: string
  alt: string
  className?: string
}

interface OEmbedResponse {
  thumbnail_url?: string
}

const Img = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`

const Placeholder = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${props => props.theme.palette.neutral.surface.darkBackground};
  color: ${props => props.theme.palette.neutral.surface.lightForeground};

  svg {
    width: ${rem(24)};
    height: ${rem(24)};
  }
`

function VimeoThumbnail(props: Props) {
  const { vimeoVideoId, alt, className } = props

  const { data: thumbnailUrl } = useQuery<string | undefined>({
    queryKey: ['vimeoThumbnailUrl', vimeoVideoId],
    queryFn: async() => {
      const videoUrl = encodeURIComponent(`https://vimeo.com/${vimeoVideoId}`)
      const response = await fetch(`https://vimeo.com/api/oembed.json?url=${videoUrl}`)
      if (response.ok) {
        const result: OEmbedResponse = await response.json()
        return result.thumbnail_url
      }
    },
    staleTime: Infinity, // Vimeo thumbnails don't change
  })

  if (!thumbnailUrl) {
    return (
      <Placeholder className={className} aria-label={alt}>
        <SolidPlayIcon />
      </Placeholder>
    )
  }

  return <Img className={className} src={thumbnailUrl} alt={alt} loading="lazy" />
}

export default memo(VimeoThumbnail)
